import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=1bea8a56&"
import script from "./dictionary.vue?vue&type=script&lang=js&"
export * from "./dictionary.vue?vue&type=script&lang=js&"
import style0 from "./dictionary.vue?vue&type=style&index=0&id=1bea8a56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports